// @flow
import * as React from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  isInternalForm: boolean,
  resourceEnabled: boolean,
  resourceType: ?string,
  measuresEnabled?: boolean,
}

type BadgeProps = {
  type: 'internal' | 'document' | 'form' | 'disabled' | 'assessment',
  text: string,
}
const Badge = ({ type, text }: BadgeProps) => {
  const colors = {
    '!border-blue-200/70 bg-blue-100 text-blue-900': type === 'form',
    'bg-orange-100/80 !border-orange-200/70 text-orange-600':
      type === 'document',
    '!border-purple-200 bg-purple-100 text-purple-600': type === 'assessment',
  }
  return (
    <div
      className={cn(
        'flex h-6 items-center gap-1 rounded border !border-gray-200/70 bg-gray-100 px-2 text-xs font-medium text-gray-600',
        colors
      )}
    >
      {text}
    </div>
  )
}

function FormControlsBadges({
  isInternalForm,
  resourceEnabled,
  resourceType,
  measuresEnabled,
}: Props): React.Node {
  return (
    <div className="flex items-center justify-end gap-2">
      {measuresEnabled && <Badge text="Assessment" type="assessment" />}
      {isInternalForm && <Badge text="Internal" type="internal" />}
      {resourceType === 'pdf' && <Badge text="Document" type="document" />}
      {resourceType === 'form' && <Badge text="Form" type="form" />}
      {!resourceEnabled && <Badge text="Disabled" type="disabled" />}
    </div>
  )
}

export default FormControlsBadges
